import Grid from '@mui/material/Grid';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const CriticalPeriod = () => {
    return (
        <Grid container justifyContent='center' sx={{ position: 'absolute', top: '-60px' }}>
            <Grid item>
                <Title size='sm' className={styles.criticText}>
                    {_('Período crítico')}
                </Title>
            </Grid>
            <Grid item>
                <Title size='sm' bolder className={styles.criticText}>
                    {_('+/- 15 días')}
                </Title>
            </Grid>
        </Grid>
    );
};

export default CriticalPeriod;
